<template>
  <div 
    class="tooltip-container"
    :style="{ 
      left: `${x}px`, 
      top: `${y}px` 
    }"
  >
    <div class="tooltip">
      <slot>{{ text }}</slot>
    </div>
  </div>
</template>

<script setup lang="ts">
defineProps<{
  text?: string
  x?: number
  y?: number
}>()
</script>

<script lang="ts">
export default {
  name: 'BaseTooltip'
}
</script>

<style scoped>
.tooltip-container {
  position: fixed;
  display: flex;
  width: 190px;
  align-items: center;
  z-index: 50;
  transform: translateY(-50%);
  pointer-events: none;
}

.tooltip {
  width: 100%;
  height: 32px;
  padding: 0 12px;
  background: #FFF;
  color: rgb(17, 24, 39);
  border-radius: 8px;
  font-size: 14px;
  line-height: 20px;
  box-shadow: 0px 2px 6px 0px rgba(16, 24, 40, 0.06);
  display: flex;
  align-items: center;
  position: relative;
  white-space: nowrap;
}

.tooltip::before {
  content: '';
  position: absolute;
  left: -4px;
  top: 50%;
  transform: translateY(-50%) rotate(45deg);
  width: 8px;
  height: 8px;
  background: #FFF;
  box-shadow: -2px 2px 4px -2px rgba(16, 24, 40, 0.06);
}
</style> 